import React, { useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';

const F1StandingsAdmin = () => {
    const [year, setYear] = useState('2026');
    const [loadingDrivers, setLoadingDrivers] = useState(false);
    const [loadingTeams, setLoadingTeams] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    // A chave fornecida para MVP conforme solicitação
    const RAPID_API_KEY = "09ff5e80b9mshecec835f99b77b7p18c17djsn1f748f8354d6";
    const RAPID_API_HOST = "f1-motorsport-data.p.rapidapi.com";

    const fetchAndSave = async (endpoint, collectionName, setLoadingState, label) => {
        setLoadingState(true);
        setMessage({ text: '', type: '' });

        try {
            const response = await fetch(`https://${RAPID_API_HOST}/${endpoint}?year=${year}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-rapidapi-host': RAPID_API_HOST,
                    'x-rapidapi-key': RAPID_API_KEY
                }
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.json();
            
            // Verifica o formato básico de F1 Motorsport Data
            // Os dados geralmente vêm num formato JSON complexo com propriedades profundas. 
            // Precisamos guardar o JSON todo e interpretar no frontend, ou guardar a raiz direto.
            // Para garantir integridade, salvamos o objeto completo vindo da requisição:
            const docRef = doc(db, collectionName, year);
            await setDoc(docRef, { data, updatedAt: new Date().toISOString() });

            setMessage({ text: `Sincronização de ${label} para o ano ${year} concluída com sucesso!`, type: 'success' });
            
        } catch (error) {
            console.error(`Erro ao sincronizar ${label}:`, error);
            setMessage({ text: `Erro ao sincronizar ${label}: ${error.message}`, type: 'error' });
        } finally {
            setLoadingState(false);
        }
    };

    const handleSyncDrivers = () => {
        fetchAndSave('standings-drivers', 'f1_standings_drivers', setLoadingDrivers, 'Pilotos');
    };

    const handleSyncTeams = () => {
        fetchAndSave('standings-controllers', 'f1_standings_teams', setLoadingTeams, 'Equipes');
    };

    return (
        <div className="bg-gray-800 p-6 rounded-xl shadow-lg border border-gray-700">
            <h2 className="text-2xl font-bold text-white mb-6 flex items-center gap-2">
                <span className="text-yellow-400">🏆</span> Sincronizar Classificação F1
            </h2>

            <div className="bg-gray-700 p-6 rounded-lg mb-8 border border-gray-600">
                <p className="text-gray-300 mb-6 text-sm">
                    Utiliza a RapidAPI (F1 Motorsport Data) para atualizar as tabelas do ano atual. 
                    <br />Isso fará requests para a API que consomem o limite do seu plano, portanto só clique após uma corrida finalizada.
                </p>

                <div className="mb-6 flex items-center gap-4">
                    <label className="text-gray-400 font-semibold" htmlFor="yearInput">Ano da Temporada:</label>
                    <input
                        id="yearInput"
                        type="number"
                        value={year}
                        onChange={(e) => setYear(e.target.value)}
                        className="px-4 py-2 bg-gray-600 border border-gray-500 rounded focus:outline-none focus:border-teal-500 text-white w-32"
                    />
                </div>

                {message.text && (
                    <div className={`mb-6 p-4 rounded text-sm ${message.type === 'error' ? 'bg-red-500/20 text-red-300 border border-red-500/50' : 'bg-green-500/20 text-green-300 border border-green-500/50'}`}>
                        {message.text}
                    </div>
                )}

                <div className="flex flex-col sm:flex-row gap-4">
                    <button
                        onClick={handleSyncDrivers}
                        disabled={loadingDrivers}
                        className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-800 disabled:cursor-not-allowed text-white font-bold py-3 px-6 justify-center rounded transition-colors flex items-center shadow-lg"
                    >
                        {loadingDrivers ? 'Puxando da API...' : '🏁 1. Atualizar Class. de Pilotos'}
                    </button>
                    
                    <button
                        onClick={handleSyncTeams}
                        disabled={loadingTeams}
                        className="flex-1 bg-purple-600 hover:bg-purple-700 disabled:bg-purple-800 disabled:cursor-not-allowed text-white font-bold py-3 px-6 justify-center rounded transition-colors flex items-center shadow-lg"
                    >
                        {loadingTeams ? 'Puxando da API...' : '🏎️ 2. Atualizar Class. de Equipes'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default F1StandingsAdmin;
